import axios from 'axios'
import qs from 'qs'
import { authData } from 'features/auth/store'
import { startsWith } from 'libs/lodash'

const BASE_URL = process.env.REACT_APP_BASE_URL

axios.interceptors.request.use(
  config => {
    return {
      ...config,
      baseURL: BASE_URL,
      withCredentials: false,
      paramsSerializer: params => {
        return qs.stringify(params, { encode: false })
      },
      headers: { 'Content-Type': 'application/json', ...config.headers },
    }
  },
  error => {
    return Promise.reject(error)
  }
)
axios.interceptors.request.use(
  async config => {
    const { isLoggedIn, token } = window.store.getState().auth.data

    if (isLoggedIn) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response?.status) {
      switch (error.response?.status) {
        case 401:
          if (window.store.getState().auth.data.isLoggedIn) {
            window.store.dispatch(authData.cleanData())
          }
          break
        case 400:
          break
        case 419:
          window.store.dispatch(authData.cleanData())

          break
        default:
          break
      }
    }
    return Promise.reject(error)
  }
)
